export default "__VITE_ASSET__B5W41YrU__"